// extracted by mini-css-extract-plugin
module.exports =  {"feedbackSubtitle":"style-module_feedbackSubtitle__fakxUXbvwrW7eDQtDufx","fullHeight":"style-module_fullHeight__qyox3VWwLZc7h7xfDXTy"};